// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TX36","toggle":"styles_toggle__1CCIo","preview":"styles_preview__As_sc"};